import { render } from "./checkrecord.vue?vue&type=template&id=5858e0f3&scoped=true&ts=true"
import script from "./checkrecord.vue?vue&type=script&lang=ts"
export * from "./checkrecord.vue?vue&type=script&lang=ts"

import "./checkrecord.vue?vue&type=style&index=0&id=5858e0f3&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5858e0f3"]])

export default __exports__